module.exports = "https://trybtryb-legacy.web.app/img/side-squares-special-mobile.cf243635.svg";